import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { transactionDetails as TEXT } from 'locales/en/transaction';

const CustomerDetails = ({ transaction }) => {
  const leftSide = useMemo(
    () => ({
      customer_name: transaction.shopper_name,
      email: transaction.shopper_email,
      country: (
        <div className="flex items-center">
          <span className="mr-1.5">{transaction.shopper_phone_country}</span>
          {transaction.shopper_country_iso2 && (
            <span
              className={`h-auto shadow-inner rounded-sm flag-icon flag-icon-${transaction.shopper_country_iso2}`}
            ></span>
          )}
        </div>
      ),
      phone: transaction.shopper_phone,
      ref: transaction.shopper_reference,
    }),
    [transaction]
  );
  const rightSide = useMemo(
    () => ({
      card_holder: transaction.cardholder_name,
      paymentMethod: transaction.payment_method,
      summary: transaction.last4,
      expiry: transaction.expiry_date,
      postal: transaction.postal_code,
    }),
    [transaction]
  );

  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.customerDetails.header}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT.customerDetails}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

CustomerDetails.propTypes = {
  transaction: PropTypes.shape({}),
};
CustomerDetails.defaultProps = {
  transaction: {},
};

export default CustomerDetails;
